import { CardHeaderToggleSmallComponent } from './card-header-toggle-small/card-header-toggle-small.component';
import { RadioInputModule } from './../forms/radio-input/radio-input.module';
import { CardHeaderToggleComponent } from './card-header-toggle/card-header-toggle.component';
import { FormsModule } from '@angular/forms';
import { CardHeaderRadioComponent } from './card-header-radio/card-header-radio.component';
import { CardHeaderImageComponent } from './card-header-image/card-header-image.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseCardHeaderComponent } from './base-card-header.component';
import { CardHeaderComponent } from './card-header/card-header.component';
import ToggleModule from '../toggle/toggle.module';

@NgModule({
  declarations: [
    BaseCardHeaderComponent,
    CardHeaderComponent,
    CardHeaderImageComponent,
    CardHeaderRadioComponent,
    CardHeaderToggleComponent,
    CardHeaderToggleSmallComponent,
  ],
  exports: [
    BaseCardHeaderComponent,
    CardHeaderComponent,
    CardHeaderImageComponent,
    CardHeaderRadioComponent,
    CardHeaderToggleComponent,
    CardHeaderToggleSmallComponent,
  ],
  imports: [CommonModule, FormsModule, ToggleModule, RadioInputModule],
})
export default class CardHeaderModule {}
